import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../../services/api';
import './SurveyAnalytics.css';


const SurveyAnalytics = () => {
  const { t } = useTranslation();
  const [cmAnalysis, setCMAnalysis] = useState(null);
  const [predictions, setPredictions] = useState(null);
  const [concerns, setConcerns] = useState(null);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    fetchAllAnalytics();
  }, []);


  const fetchAllAnalytics = async () => {
    try {
      setLoading(true);
      const [cmRes, predRes, concernRes] = await Promise.all([
        api.getCMPreferenceAnalysis(),
        api.getWinnerPredictions(),
        api.getMainConcerns()
      ]);
      
      setCMAnalysis(cmRes?.data);
      setPredictions(predRes?.data);
      setConcerns(concernRes?.data);
    } catch (error) {
      console.error('❌ Error fetching analytics:', error);
    } finally {
      setLoading(false);
    }
  };


  if (loading) {
    return (
      <div className="analytics-page">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>{t('common.loading') || 'Loading analytics...'}</p>
        </div>
      </div>
    );
  }


  return (
    <div className="analytics-page">
      <div className="analytics-container">
        <h1>{t('surveyAnalytics.title') || 'Election Survey Analytics'}</h1>
        
        {/* CM Preferences */}
        <section className="analytics-section">
          <h2>{t('surveyAnalytics.cmPreferences') || 'Chief Minister Preferences'}</h2>
          <div className="analytics-grid">
            {cmAnalysis?.map((cm, index) => (
              <div key={index} className="analytics-card">
                <h3>{cm.chiefMinister}</h3>
                <p>
                  {cm.votes} {t('common.votes') || 'votes'} ({cm.percentage}%)
                </p>
              </div>
            ))}
          </div>
        </section>
        
        {/* Winner Predictions */}
        <section className="analytics-section">
          <h2>{t('surveyAnalytics.winnerPredictions') || 'Winner Predictions'}</h2>
          <div className="analytics-grid">
            {predictions?.map((pred, index) => (
              <div key={index} className="analytics-card">
                <h3>{pred.expectedWinner}</h3>
                <p>
                  {pred.predictions} {t('surveyAnalytics.predictions') || 'predictions'}
                </p>
                <p>
                  {t('surveyAnalytics.avgConfidence') || 'Avg Confidence'}: {pred.averageConfidence}/5
                </p>
              </div>
            ))}
          </div>
        </section>
        
        {/* Main Concerns */}
        <section className="analytics-section">
          <h2>{t('surveyAnalytics.mainConcerns') || 'Main Voter Concerns'}</h2>
          <div className="concerns-list">
            {concerns?.map((concern, index) => (
              <div key={index} className="concern-item">
                <div className="concern-header">
                  <h3>{concern.concern}</h3>
                  <span className="percentage">{concern.percentage}%</span>
                </div>
                <p>
                  {concern.count} {t('surveyAnalytics.mentions') || 'mentions'}
                </p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};


export default SurveyAnalytics;
